// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608251134/js/" + chunkId + "." + {"44":"cecc22d8","225":"53d91f1b","481":"4a9c59c9","486":"ba8e9993","770":"619e4f33"}[chunkId] + ".0.5226086743694003.chunk.js";
};